import { Component, OnInit, HostListener } from '@angular/core';
import { CompaniesService } from '../../services/companies.service';
import { Company } from '../../models/Company.model';
import { CompanyGroup } from '../../models/CompanyGroup.model';
import { CompanyGroupSearch } from "../../models/CompanyGroupSearch.model";
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { CompanySearch } from '../../models/CompanySearch.model';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { DropDownList } from '../../models/DropDownList.model';
import { Industry } from '../../models/Industry.model';
import { IndustriesService } from '../../services/industries.service';
import { Json2csvService } from "../../services/json2csv.service";
import { GUARDS } from '../../shared/auth/Roles';
import * as moment from "moment";

moment.locale('pt-br');
@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {

  itemsPerPage: number[] = [10, 50, 100];
  totalItems: number = 0;
  currentPage: number = 1;

  dropDownListCompanyGroups: DropDownList[] = new Array<DropDownList>();
  selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
  dropDownCompanyGroupsSettings = {};
  GUARDS = GUARDS;

  dropDownListIndustries: DropDownList[] = new Array<DropDownList>();
  selectedIndustriesItems: DropDownList[] = new Array<DropDownList>();
  dropDownIndustriesSettings = {};

  companies: Company[] = null;
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  industry: Industry[] = new Array<Industry>();
  companyGroupSearchModel: CompanyGroupSearch;
  commonHelper: CommonHelper = new CommonHelper();
  companySearchModel: CompanySearch;
  months;
  years;
  user;
  loading: boolean;
  vendorSearchExecuted: boolean = false;

  constructor(private companiesService: CompaniesService,
    private json2csvService: Json2csvService,
    private industriesService: IndustriesService,
    private localStorage: LocalStorage) { }

  async ngOnInit() {
    this.loading = true;
    this.user = this.localStorage.retrieve('user');
    this.months = this.commonHelper.listAllMonths();
    this.years = this.commonHelper.listLastYears();

    this.companySearchModel = this.localStorage.retrieve('company')?this.localStorage.retrieve('company'):new CompanySearch();
    this.companySearchModel.onlyCustomer = true;
    if(!this.companySearchModel.hasOwnProperty('companyGroup')) this.companySearchModel.companyGroup = [];

    this.industry = await this.industriesService.getAll();
    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);
    this.dropDownListCompanyGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
    this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(true, 'Grupo de empresa', false, 'Marcar todas os grupos', 'Desmarcar todas os grupos', true,null, '');
    this.dropDownListIndustries = this.commonHelper.getDropDownListItems(this.industry, "_id", "name");
    this.dropDownIndustriesSettings = this.commonHelper.getDropDownSettings(false, 'Selecione um Setor', false, 'Marcar todas os grupos', 'Desmarcar todas os grupos', true,null, '');

    await this.searchCompanies(1);
    this.loading = false;
  }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchCompanies(1);
        }

    }

  async searchCompanies(page?: number, toexport?: boolean) {
    let limit, skip;
    this.loading = true;
    this.currentPage = page ? page : 1;
    this.companySearchModel.skip = (this.currentPage - 1) * this.companySearchModel.limit;

    if (toexport) {
       limit = this.companySearchModel.limit;
       skip = this.companySearchModel.skip;
       delete this.companySearchModel.skip;
       delete this.companySearchModel.limit;
    }
    this.companySearchModel.industries = this.selectedIndustriesItems.map(cg => cg.id);

    this.companySearchModel.onlyExternalReference = false;
    this.companySearchModel.companyGroup = this.selectedCompanyGroupsItems.map(cg => cg.id);
    this.companies = await this.companiesService.searchCompanies(this.companySearchModel);
    this.totalItems = this.companySearchModel.totalItems;

    if(toexport) {
        this.companySearchModel.skip = skip;
        this.companySearchModel.limit = limit;
    }

    this.localStorage.persist('company',this.companySearchModel);
    this.vendorSearchExecuted = this.companySearchModel.onlyCustomer ? false : true;
    this.loading = false;
  }

  isActive(active: boolean) {
    return active ? "badge-success" : "badge-danger";
  }

  isActiveText(active: boolean) {
    return active ? "Ativo" : "Inativo";
  }

  async export() {
    await this.searchCompanies(1, true);
      if(!this.companies) {
        return;
      }
      this.json2csvService.export(
      this.companies.map(pjShow => {
        return {
          "Nome Fantasia": pjShow.name ? pjShow.name : "",
          "Razão Social": pjShow.companyName ? pjShow.companyName : "",
          "CNPJ": pjShow.cnpj ? pjShow.cnpj : '',
          "Grupo de empresa": pjShow.isCustomer && pjShow.companyGroup ? pjShow.companyGroup.name:"-",
          "Tipo": pjShow.isCustomer ? "Cliente" : "Fornecedor",
          "Status": pjShow.active ? "Ativo" : "Inativo",
          "Proprietário": pjShow.subscriber ? pjShow.subscriber : "-",
          "Início da Empresa": pjShow.start ? moment(pjShow.start).format("DD/MM/YYYY") : "-",
          "Fim da Empresa": pjShow.end ? moment(pjShow.end).format("DD/MM/YYYY") : "-" ,
          "Setor": pjShow.industry? pjShow.industry.name : '-',
          "Contratos": pjShow.contracts ? this.trancriptContractsTypes(pjShow.contracts): "-",
          "SAP": pjShow.sapCardCode ? pjShow.sapCardCode : ''
        };

    }),
    `Companies - ${new Date().toLocaleDateString('pt-br')}`
    );
  }

  trancriptContractsTypes(contracts){
    let contract = contracts.map((c, index) => {
      return ` ${index + 1} # - Inicio: ${moment(c.contractStart).format('DD/MM/YYYY')} - Fim: ${moment(c.contractEnd).format('DD/MM/YYYY')} - Tipo: ${c.contractTypes ? c.contractTypes.name:""} - Reajuste: ${moment(c.readjustmentDate).format('DD/MM/YYYY')} - Responsável do contrato: ${c.responsible ? c.responsible.name:""} - Centro de excelência: ${c.excellenceCenter ? c.excellenceCenter.name:""}`
    });
        return contract.join(' | ')
  };
}



// WEBPACK FOOTER //
// ./src/app/views/companies/companies.component.ts